import { render, staticRenderFns } from "./CoChain.vue?vue&type=template&id=3b3bd783&scoped=true&"
import script from "./CoChain.vue?vue&type=script&lang=js&"
export * from "./CoChain.vue?vue&type=script&lang=js&"
import style0 from "./CoChain.vue?vue&type=style&index=0&id=3b3bd783&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bd783",
  null
  
)

export default component.exports